
import { defineComponent } from 'vue'
import personalInfo from '@/constants/consentForPersonalData'

/**
 * 個人情報説明
 */
export default defineComponent({
  name: 'PersonalInfo',
  setup() {
    return {
      personalInfo,
    }
  },
})
